import { render, staticRenderFns } from "./talk-list.vue?vue&type=template&id=15b658e6&lang=pug&"
import script from "./talk-list.vue?vue&type=script&lang=js&"
export * from "./talk-list.vue?vue&type=script&lang=js&"
import style0 from "./talk-list.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports